import React from 'react';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

import Translation from '../../../../UI/Translation';

import { BoldText, CheckboxStyled, SingleNotificationViewContainer } from '../../style';

interface SingleNotificationViewProps {
  id: AppConfig.NotificationAdmin['id'];
  title: AppConfig.NotificationAdmin['title'];
  message: AppConfig.NotificationAdmin['message'];
  alwaysDisplay: AppConfig.NotificationAdmin['alwaysDisplay'];
  handleChange: (e: CheckboxChangeEvent, value: AppConfig.NotificationAdmin['id']) => void;
  isFirstChild: boolean;
}

/**
 * Widok pojedynczej notyfikacji
 *
 */
const SingleNotificationView = ({
  id,
  title,
  message,
  alwaysDisplay,
  handleChange,
  isFirstChild,
}: SingleNotificationViewProps): JSX.Element => (
  <SingleNotificationViewContainer borderTop={isFirstChild}>
    <BoldText>{title}</BoldText>
    <p>{message}</p>
    {!alwaysDisplay && (
      <CheckboxStyled onChange={e => handleChange(e, id)}>
        <Translation id={'NO_SHOW_AGAIN'} />
      </CheckboxStyled>
    )}
  </SingleNotificationViewContainer>
);

export default SingleNotificationView;
